import React, { useEffect, useState } from "react";
import backgroundModule from "@dytesdk/background-changer-module";

import { useNavigate, useParams } from "react-router-dom";
import { useDyteClient } from "@dytesdk/react-web-core";
import { DyteMeeting, extendConfig } from "@dytesdk/react-ui-kit";
import { joinExistingRoom } from "../utils";
import ClipLoader from "react-spinners/ClipLoader";
import DyteVideoBackgroundTransformer from "@dytesdk/video-background-transformer";

export const SimpleDyteClient: React.FC<{}> = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const navigate = useNavigate();
  const params = useParams<{ id: string; room: string }>();
  const auth = sessionStorage.getItem("auth");
  const roomName = sessionStorage.getItem("roomName");
  const blurr = sessionStorage.getItem("blurr");
  let videoBackgroundTransformer;
  console.log(blurr);
  const [meeting, initMeeting] = useDyteClient();
  const [vb, setVB] = useState();
  const [isChecked, setIsChecked] = useState(false);
  // const videoBackgroundTransformer =
  //   await DyteVideoBackgroundTransformer.init();
  // const handleOnChange = async () => {
  //   setIsChecked(!isChecked);
  //   if (isChecked) {
  //      videoBackgroundTransformer =
  //       await DyteVideoBackgroundTransformer.init();
  //     meeting?.self.addVideoMiddleware(
  //       await videoBackgroundTransformer.createBackgroundBlurVideoMiddleware(15)
  //     );
  //   } else {
  //     if (videoBackgroundTransformer){

  //     }

  //     meeting?.self.addVideoMiddleware(
  //       await videoBackgroundTransformer.createBackgroundBlurVideoMiddleware(0)
  //     );
  //   }
  // };

  useEffect(() => {
    if (auth && roomName && params.id) {
      initMeeting({
        authToken: auth,
        roomName,
        defaults: {
          video: true,
          audio: true,
        },
      });
    }

    if (!auth && !roomName && params.id && params.room) {
      //creating a new participant
      joinExistingRoom(params.id, params.room);
    }
  }, []);

  useEffect(() => {
    const setVBInit = async () => {
      const videoBackgroundTransformer =
        await DyteVideoBackgroundTransformer.init();
      meeting?.self.addVideoMiddleware(
        await videoBackgroundTransformer.createBackgroundBlurVideoMiddleware(15)
      );
      return videoBackgroundTransformer;
    };
    if (meeting) {
      if (blurr === "true") {
        setVBInit();
      }

      meeting.meta.on("disconnected", () => {
        sessionStorage.clear();
        navigate("/");
      });
    }
  }, [meeting, navigate]);

  const config = extendConfig({
    root: {
      "dyte-mixed-grid": {
        states: ["activeSpotlight"],
        children: [["dyte-simple-grid", { style: { flexGrow: "8" } }]],
      },
    },
  });

  if (!meeting) {
    return (
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div></div>
      <div style={{ height: "100vh", width: "100vw" }}>
        <DyteMeeting mode="fill" meeting={meeting} config={config} />
      </div>
    </div>
  );
};
